import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { type Employees } from 'modules/employees/store/collections/employees'

import DirectReports from './DirectReports'
import Overview from './Overview'

const ReportsDetails = ({
  contractVersions,
  employees,
}: {
  contractVersions: ContractVersions
  employees: Employees
}) => {
  return (
    <Box>
      <Overview employees={employees} />

      <DirectReports contractVersions={contractVersions} employees={employees} />
    </Box>
  )
}

export default ReportsDetails
